// custom hook for getting previous value
import {useEffect, useRef} from "react";

function usePrevious<T>(value: T): T | null {
    const ref = useRef<T | null>(null);
    useEffect(() => {
        ref.current = value;
    }, [value]);

    // eslint-disable-next-line react-hooks/refs -- reading ref.current as the hook's return is the standard usePrevious pattern
    return ref.current;
}

export default usePrevious;